import { render, staticRenderFns } from "./CodePacket.vue?vue&type=template&id=3b07b97c&scoped=true"
import script from "./CodePacket.vue?vue&type=script&lang=js"
export * from "./CodePacket.vue?vue&type=script&lang=js"
import style0 from "./CodePacket.vue?vue&type=style&index=0&id=3b07b97c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b07b97c",
  null
  
)

export default component.exports